import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, message, Modal, Row, Select } from 'antd';
import {
  queryDeleteMaterialDocument,
  queryMaterialDatabaseDelete,
  queryMaterialDatabaseInfo,
  queryMaterialDatabaseListBR,
  queryMaterialDatabaseSave,
  queryMaterialDatabaseType,
  queryMaterialDirectoryList,
  queryMaterialDocumentList,
} from '@api/administrative/material';
import { connect } from 'react-redux';
import { setBackInfo } from '@store/modules/back_info';
import TreeOrg from '../TreeOrg';
import ModalAdd from '../ModalAdd';
import TableOrg from '../TableOrg';
import SelectOrg from '../SelectDatabase';

const { confirm } = Modal;
const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      databaseName: '',
      databaseUuid: '',
      databaseList: [],
      databaseInfo: {},

      directory: '',
      directoryUuid: '',
      directoryList: [],

      documentList: [],
      types: [],
      documentType: '',
      documentCondition: '',

      pagination: {},
      isLoading: false,
      addVisible: false,
      emptyFlag: true,
      isAddType: true,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { backInfo } = this.props;
    if (backInfo.path === this.props.location.pathname) {
      this.getDatabaseList();
      // 分页设置
      backInfo.start && backInfo.limit && (this.current = backInfo.start);
      backInfo.start &&
        backInfo.limit &&
        (this.pagination = {
          limit: backInfo.limit,
          start: backInfo.start,
        });
      this.setState(
        {
          databaseName: backInfo.databaseName,
          databaseUuid: backInfo.databaseUuid,
          directory: backInfo.directory,
          directoryUuid: backInfo.directoryUuid,
          documentType: backInfo.documentType,
          documentCondition: backInfo.documentCondition,
        },
        () => {
          this.getDatabaseType();
          this.getDirectoryList();
          this.getDocumentList();
        },
      );
    } else {
      this.initialPage();
    }
  }

  componentWillUnmount() {
    const {
      databaseName,
      databaseUuid,
      directory,
      directoryUuid,
      documentType,
      documentCondition,
    } = this.state;
    const params = {
      path: this.props.location.pathname,
      ...this.pagination,
      databaseName,
      databaseUuid,
      directory,
      directoryUuid,
      documentType: documentType || '',
      documentCondition: documentCondition || '',
    };
    this.props.dispatch(setBackInfo(params));
  }

  // 页面初始状态
  initialPage = () => {
    queryMaterialDatabaseListBR().then(res => {
      // 资料库列表
      if (res.statusCode === 200) {
        if (res.data.length === 0) {
          this.setState({ emptyFlag: true });
        } else {
          this.setState(
            {
              databaseList: res.data || [],
              databaseUuid: res.data[0] ? res.data[0].uuid : '',
              databaseName: res.data[0] ? res.data[0].name : '',
              emptyFlag: false,
            },
            () => {
              const { databaseUuid, databaseName } = this.state;
              this.handleDatabaseChange(databaseUuid, {
                props: { children: databaseName },
              });
            },
          );
        }
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  // 获取资料类型
  getDatabaseType = () => {
    const { databaseUuid } = this.state;
    queryMaterialDatabaseType({ databaseUuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          types: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 资料库列表
  getDatabaseList = () => {
    queryMaterialDatabaseListBR().then(res => {
      if (res.statusCode === 200) {
        if (res.data.length === 1) {
          // 首次创建资料库
          this.setState({
            databaseList: res.data || [],
            databaseUuid: res.data[0] ? res.data[0].uuid : '',
            databaseName: res.data[0] ? res.data[0].name : '',
            emptyFlag: false,
          });
          this.databaseList = res.data;
        } else if (res.data.length > 0) {
          this.setState({
            databaseList: res.data || [],
            emptyFlag: false,
          });
          this.databaseList = res.data;
        } else {
          this.setState({
            emptyFlag: true,
          });
        }
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  // 资料库详情
  getDatabaseInfo = () => {
    const { databaseUuid } = this.state;
    queryMaterialDatabaseInfo({ uuid: databaseUuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          databaseInfo: res.data || [],
        });
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  // 资料库删除
  getDatabaseDelete = () => {
    const { databaseUuid } = this.state;
    queryMaterialDatabaseDelete({ uuid: databaseUuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message, 2.5);
        this.initialPage();
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  // 资料目录列表
  getDirectoryList = () => {
    const { databaseUuid } = this.state;
    queryMaterialDirectoryList({
      databaseUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          directoryList: res.data || [],
        });
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  // 资料文档列表
  getDocumentList = () => {
    const { databaseUuid, directoryUuid, documentType, documentCondition } = this.state;
    const params = {
      databaseUuid,
      directoryUuid,
      type: documentType,
      ...this.pagination,
      condition: documentCondition,
    };
    this.setState({
      isLoading: true,
    });
    queryMaterialDocumentList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          documentList: res.data || [],
          pagination: {
            total: res.totalSize,
            pageSize: 15,
            current: this.current,
          },
          isLoading: false,
        });
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  // 资料库改变(也用于初始状态)
  handleDatabaseChange = (value, option) => {
    this.pagination = {
      limit: 15,
      start: 1,
    };
    this.current = 1;
    this.setState(
      {
        databaseUuid: value,
        databaseName: option.props.children,
        directory: '',
        directoryUuid: '',
      },
      () => {
        this.getDirectoryList();
        this.getDatabaseType();
        this.getDocumentList();
      },
    );
  };

  // 资料目录选中
  handleDirectorySelect = value => {
    this.setState(
      {
        directoryUuid: value.uuid,
        directory: value.name,
      },
      () => {
        this.getDocumentList();
      },
    );
  };

  // 资料文档搜索
  handleSearch = () => {
    this.props.form.validateFields((err, values) => {
      const documentType = values.documentType || '';
      const documentCondition = values.condition || '';
      this.setState(
        {
          documentType,
          documentCondition,
        },
        () => {
          this.getDocumentList();
        },
      );
    });
  };

  /** ------------------新增/编辑资料库--------------------------------------------*/
  // 弹窗开关
  hideModalAdd = flag => {
    this.setState({
      addVisible: !!flag,
    });
  };

  // 新增的弹窗
  addDatabase = () => {
    this.setState({ isAddType: true }, () => {
      this.hideModalAdd(true);
    });
  };

  // 编辑的弹窗
  editDatabase = () => {
    const { databaseUuid } = this.state;
    this.getDatabaseInfo(databaseUuid);
    this.setState({ isAddType: false }, () => {
      this.hideModalAdd(true);
    });
  };

  // 提交
  databaseAddSubmit = params => {
    queryMaterialDatabaseSave(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getDatabaseList();
        this.hideModalAdd();
      } else {
        message.error(res.message);
      }
    });
  };

  /**-----------------------------------------------------------------------------*/
  // 删除资料库
  showDel = () => {
    const _this = this;
    confirm({
      title: '确定删除该资料库?',
      onOk() {
        _this.getDatabaseDelete();
      },
    });
  };

  // 添加资料文档
  documentAdd = () => {
    const { databaseUuid, directoryUuid } = this.state;
    this.props.router.push({
      pathname: `/administrative/material/add/new`,
      query: {
        databaseUuid,
        directoryUuid,
      },
    });
  };

  handleDel = uuid => {
    queryDeleteMaterialDocument({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message, 2.5);
        this.getDocumentList();
      }
    });
  };

  handleTableChange = pagination => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.getDocumentList();
  };

  render() {
    const {
      databaseUuid,
      databaseName,
      databaseList,
      databaseInfo,
      directoryUuid,
      directoryList,
      documentList,
      types,
      pagination,
      documentType,
      documentCondition,
      isLoading,
      isAddType,
      emptyFlag,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    const parentProps = {
      databaseUuid,
      databaseName,
      directoryUuid,
      documentList,
      pagination,
      isLoading,
      handleDel: this.handleDel,
      onChange: this.handleTableChange,
    };

    const formItemLayout = {
      labelCol: {
        xs: { span: 12 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
        md: { span: 18 },
      },
    };

    return (
      <div>
        {emptyFlag ? (
          <Button style={{ marginLeft: '10px' }} onClick={this.addDatabase}>
            新增资料库
          </Button>
        ) : (
          <Row>
            <Col span={6}>
              <Row style={{ paddingBottom: '15px' }}>
                <SelectOrg
                  data={databaseList}
                  onChange={this.handleDatabaseChange}
                  value={databaseUuid}
                />
              </Row>
              <TreeOrg
                data={directoryList}
                database={databaseName}
                databaseUuid={databaseUuid}
                directoryUuid={directoryUuid}
                onSelect={this.handleDirectorySelect}
                getDirectoryList={this.getDirectoryList}
              />
            </Col>
            <Col span={18} style={{ paddingLeft: '2%' }}>
              <Row type="flex" justify="end" style={{ paddingBottom: '15px' }}>
                <Button type="primary" onClick={this.documentAdd}>
                  + 添加资料
                </Button>
                <Button style={{ marginLeft: '10px' }} onClick={this.editDatabase}>
                  编辑资料库
                </Button>
                <Button style={{ marginLeft: '10px' }} onClick={this.addDatabase}>
                  新增资料库
                </Button>
                <Button style={{ marginLeft: '10px' }} onClick={this.showDel}>
                  删除资料库
                </Button>
              </Row>
              <Card>
                <Form>
                  <Row>
                    <Col span={6}>
                      <FormItem label="类型" {...formItemLayout}>
                        {getFieldDecorator('documentType', {
                          initialValue: documentType,
                        })(
                          <Select allowClear>
                            {types.map(item => {
                              return (
                                <Select.Option value={item.name} key={item.name}>
                                  {item.name}
                                </Select.Option>
                              );
                            })}
                          </Select>,
                        )}
                      </FormItem>
                    </Col>
                    <Col span={4} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                      <FormItem>
                        {getFieldDecorator('condition', {
                          initialValue: documentCondition,
                        })(<Input placeholder="其他搜索" />)}
                      </FormItem>
                    </Col>
                    <Col span={3}>
                      <FormItem>
                        <Button type="primary" onClick={this.handleSearch}>
                          搜索
                        </Button>
                      </FormItem>
                    </Col>
                  </Row>
                </Form>
                <TableOrg {...parentProps} />
              </Card>
            </Col>
          </Row>
        )}
        <ModalAdd
          visible={this.state.addVisible}
          onOk={this.databaseAddSubmit}
          onCancel={() => this.hideModalAdd(false)}
          data={isAddType ? {} : databaseInfo}
        />
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
}))(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/administrative/material/myMaterical/Index.js